import React, { useEffect, useState, useContext } from 'react'
import { useParams, Link } from 'react-router-dom'
import IPPSservice from 'services/IPPSservice'
import { upload } from '../../services/mcp.service'
import ReactForm from 'ua-react-form'
const { Create } = ReactForm
import _ from 'lodash'

const CreateNotification = () => {
    const [context, setContext] = useState({ body: {} })
    const [segments, setSegments] = useState([])
    const [pages, setPages] = useState([])

    const onChange = ({ target }) => {
        let con = context
        _.set(con, target.name, target.value)
        setContext(con)
        console.log(con)
    }

    const onChangeImage = async ({ target }) => {
        try {
            if (target.files && target.files[0]) {
                let img = target.files[0]
                const data = new FormData()
                data.append('image', img)
                let result = await upload(data)

                if (result.status_code !== 0) {
                    throw new Error(result.status)
                }

                let con = context
                _.set(con, target.name, result.data.path)
                setContext(con)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const onSubmit = async event => {
        try {
            event.preventDefault()
            const result = await IPPSservice.createIPPS('notification', context)
            console.log(result)
        } catch (err) {
            console.log(err)
        }
    }

    const getSegments = async () => {
        try {
            let segment = await IPPSservice.getIPPS('segment')
            segment = segment.map(seg => ({
                label: seg.name,
                value: seg.short_code
            }))
            setSegments([
                { value: '-1', label: 'Сегмэнт сонгоно уу!' },
                ...segment
            ])
        } catch (err) {
            console.log(err)
            setSegments([])
        }
    }

    const getPages = async () => {
        try {
            let pages = await IPPSservice.getNotificationPages()
            pages = pages.map(page => ({
                value: page._id,
                label: page.name
            }))
            setPages([{ value: '-1', label: 'Page Сонгоно уу!' }, ...pages])
        } catch (err) {
            console.log(err)
            setPages([])
        }
    }

    useEffect(async () => {
        await getSegments()
        await getPages()
    }, [])

    const title = 'Create Notification'

    const fields = [
        {
            type: 'text',
            isRequired: true,
            name: 'Title',
            fieldName: 'body.title',
            onChange: onChange
        },
        {
            type: 'select',
            isRequired: true,
            name: 'Segment',
            fieldName: 'body.segment',
            options: segments,
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'Sub Title',
            fieldName: 'body.sub_title',
            onChange: onChange
        },
        {
            type: 'select',
            isRequired: true,
            name: 'Дарахад хийх үйлдэл',
            fieldName: 'notification_page',
            onChange: onChange,
            options: pages
        },
        {
            type: 'text',
            isRequired: true,
            name: 'Body',
            fieldName: 'body.body',
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'Нөхцлийн код',
            fieldName: 'body.action',
            onChange: onChange
        },
        {
            type: 'file',
            isRequired: true,
            name: 'Icon',
            fieldName: 'body.icon_url',
            onChange: onChangeImage
        },
        {
            type: 'datetime-local',
            isRequired: true,
            name: 'Явж эхлэх огноо',
            fieldName: 'send_by',
            onChange: onChange
        }
    ]
    return (
        <Create
            fields={fields}
            title={title}
            context={context}
            onSubmit={onSubmit}
        ></Create>
    )
}
const CreatePage = () => {
    const [context, setContext] = useState({ body: {} })

    const onChange = ({ target }) => {
        let con = context
        _.set(con, target.name, target.value)
        setContext(con)
        console.log(con)
    }

    const onSubmit = async ({ target }) => {
        try {
            const result = await IPPSservice.createIPPS(
                'notification/page',
                context
            )
            console.log(result)
        } catch (err) {
            console.log(err)
        }
    }

    const title = 'Create Page'

    const fields = [
        {
            type: 'text',
            isRequired: true,
            name: 'Нэр',
            fieldName: 'name',
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'ios',
            fieldName: 'ios',
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'android',
            fieldName: 'android',
            onChange: onChange
        },
        {
            type: 'text',
            isRequired: true,
            name: 'action',
            fieldName: 'action',
            onChange: onChange
        }
    ]
    return (
        <div>
            <Create
                fields={fields}
                title={title}
                context={context}
                onSubmit={onSubmit}
            ></Create>
        </div>
    )
}
const index = () => {
    return (
        <div className="page-content">
            <CreateNotification></CreateNotification>
            <CreatePage></CreatePage>
        </div>
    )
}
export default index
